import axios from "../../utils/axios"

export const getFaqs=async()=>{
    return await axios.get("api/faq/true")
}